// extracted by css-extract-rspack-plugin
export default {"dialogBody":"custom-properties-sidebar-form-module__dialogBody__RRiJN"};